<template>
  <div class="footer">
    <div class="max-width">
      <span>{{ 'Footer'/* ___ */ }}</span>
    </div>
  </div>
</template>

<script>
export default {
}
</script>



// WEBPACK FOOTER //
// src/components/layout/footer.vue